import { axiosInstance as request } from '@api/rest.service'

const api = '/reports'

/**
 * @description GET /reports/types
 * @returns {AxiosPromise<any>}
 */
export const GET_REPORT_TYPES = () => request.get(`${api}/types`)

/**
 * @description GET /reports/types/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_REPORT_TYPE = id => request.get(`${api}/types/${id}`)

/**
 * @description GET /reports/types/{id}/preview?paginated=true
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_REPORT_TYPE_PREVIEW = (id, params) =>
  request.get(`${api}/types/${id}/preview?paginated=true`, { params })

/**
 * @description GET /reports/preview/{id}?paginated=true
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_REPORTS_PREVIEW = (id, params) =>
  request.get(`${api}/preview/${id}?paginated=true`, { params })

/**
 * @description GET /reports/preview/{id}/generate
 * @returns {AxiosPromise<any>}
 */
export const GET_REPORTS_PREVIEW_GENERATE = (id, params) => request.get(`${api}/preview/${id}/generate`, { params })

/**
 * @description GET /reports
 * @returns {AxiosPromise<any>}
 */
export const GET_REPORTS = () => request.get(api)

/**
 * @description GET /reports/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_REPORT = id => request.get(`${api}/${id}`)

/**
 * @description PUT /reports/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_REPORT = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /reports/{id}/generate
 * @returns {AxiosPromise<any>}
 */
export const GENERATE_REPORT = id => request.get(`${api}/${id}/generate`)

/**
 * @description POST /reports
 * @returns {AxiosPromise<any>}
 */
export const CREATE_REPORT = payload => request.post(api, payload)

/**
 * @description DELETE /reports/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_REPORT = id => request.delete(`${api}/${id}`)
